import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * The app's tooltip around a single control — the dark pill the AI and manual
 * editors use, instead of the browser's native `title` popup, which is slow to
 * appear, unstyled and invisible on touch.
 *
 * The child must be one element that takes a ref (a button, label, div…). With
 * no `label` the child is returned untouched.
 *
 * Opens below the control by default, like the editors' toolbars.
 *
 * @param {{ label?: import('react').ReactNode, side?: 'top'|'bottom'|'left'|'right',
 *   children: import('react').ReactElement }} props
 */
export default function Hint({ label, side = 'bottom', children }) {
    if (!label) return children;
    return (
        <Tooltip>
            <TooltipTrigger asChild>{children}</TooltipTrigger>
            <TooltipContent side={side}>{label}</TooltipContent>
        </Tooltip>
    );
}
